export function createXLSheetdata(attendanceList) {
    attendanceList.find((ticketDetails, index) => {
                
               

                // attendanceList[index].Created=attendanceList[index].created
                // delete attendanceList[index]['created']


                return false
            })   
            return attendanceList
}

export function createXLSheetdataSimpliedFormat(attendanceList) {
    attendanceList.find((ticketDetails, index) => {
                

                attendanceList[index].EmployeeId=attendanceList[index]['employee_id']
                delete attendanceList[index]['employee_id']

                attendanceList[index].EmployeeName=attendanceList[index]['employee_name']
                delete attendanceList[index]['employee_name']
                
                attendanceList[index].Designation=attendanceList[index]['designation']
                delete attendanceList[index]['designation']



                attendanceList[index].AttendanceDate=attendanceList[index]['attendance_date']
                delete attendanceList[index]['attendance_date']
                
                attendanceList[index].Type=attendanceList[index]['attendance_type']
                delete attendanceList[index]['attendance_type']
                

                attendanceList[index].WorkLocationType=attendanceList[index]['work_location_type']
                delete attendanceList[index]['work_location_type']

                
                attendanceList[index].WorkLocation=attendanceList[index]['work_location']
                delete attendanceList[index]['work_location']

                attendanceList[index].Reason=attendanceList[index]['reason_attendance']
                delete attendanceList[index]['reason_attendance']

                attendanceList[index].Remarks=attendanceList[index]['remarks_attendance']
                delete attendanceList[index]['remarks_attendance']


                // attendanceList[index].Created=attendanceList[index].created
                // delete attendanceList[index]['created']


                return false
            })   
            return attendanceList
}







// WEBPACK FOOTER //
// ./src/modules/Attendance/services/helpers.js